// //client/src/api/dashboardApi.js
// import axios from "axios";

// export async function getDashboardStats() {
//   const response = await axios.get(
//     "/api/reports/dashboard-stats"
//   );

//   return response.data;
// }

// export async function getInvoices(
//   filters = {}
// ) {
//   const response = await axios.get(
//     "/api/reports/invoices",
//     {
//       params: filters,
//     }
//   );

//   return response.data;
// }


// //client/src/api/dashboardApi.js

// import axios from "axios";

// export async function getDashboardStats() {

//   const response =
//     await axios.get(
//       "/api/reports/dashboard-stats"
//     );

//   return response.data;
// }

// export async function getInvoices(
//   filters = {}
// ) {

//   const response =
//     await axios.get(
//       "/api/reports/invoices",
//       {
//         params: filters,
//       }
//     );

//   return response.data;
// }

// export async function exportReport(
//   filters = {}
// ) {

//   const response =
//     await axios.post(
//       "/api/reports/export",
//       filters
//     );

//   return response.data;
// }


//client/src/api/dashboardApi.js

import axios from "axios";

export async function getDashboardStats() {

  const response =
    await axios.get(
      "/api/reports/dashboard-stats"
    );

  return response.data;
}

export async function getInvoices(
  filters = {}
) {

  const response =
    await axios.get(
      "/api/reports/invoices",
      {
        params: filters,
      }
    );

  return response.data;
}

export async function getQuarters() {

  const response =
    await axios.get(
      "/api/reports/quarters"
    );

  return response.data;
}

export async function exportReport(
  filters = {}
) {

  const response =
    await axios.post(
      "/api/reports/export",
      filters
    );

  return response.data;
}